import { useState } from 'react';
import Layout from '../registration/components/Layout';
import { LoginForm } from './LoginFormPage';
import { ResetPasswordByEmail } from './ResetPasswordByEmailPage';
import { ResetPasswordForm } from './ResetPasswordFormPage';
import { ResetPasswordSuccessPage } from './ResetPasswordSuccessPage';
import { PageSegment } from '..';

export enum PageName {
  LoginForm = 'LOGIN_FORM',
  ResetPassword = 'RESETPASSEORD',
  ResetPasswordForm = 'RESETPASSWORDFORM',
  ResetPasswordSuccess = 'RESETPASSWORDSUCCESS'
}

export const LoginPage = (props: {
  setActivePage: React.Dispatch<React.SetStateAction<PageSegment>>;
  facilityName?: string;
  fromLine?: boolean;
}) => {
  const [activePage, setActivePage] = useState(PageName.LoginForm);
  const [userName, setUserName] = useState('');

  switch (activePage) {
    case PageName.LoginForm:
      return (
        <Layout
          title={props.facilityName || 'ログイン'}
          backButton={true}
          noMyPage={true}
          handleBack={() => props.setActivePage(PageSegment.Top)}
        >
          <LoginForm setActivePage={setActivePage} fromLine={props.fromLine} />
        </Layout>
      );
    case PageName.ResetPassword:
      return (
        <Layout
          title={props.facilityName || 'パスワード変更'}
          backButton={true}
          noMyPage={true}
          handleBack={() => props.setActivePage(PageSegment.Top)}
        >
          <ResetPasswordByEmail setActivePage={setActivePage} setUserName={setUserName} />
        </Layout>
      );
    case PageName.ResetPasswordForm:
      return (
        <Layout title={props.facilityName || 'パスワード変更'} backButton={false} noMyPage={true}>
          <ResetPasswordForm setActivePage={setActivePage} userName={userName} />
        </Layout>
      );
    case PageName.ResetPasswordSuccess:
      return (
        <Layout title={props.facilityName || 'パスワード変更'} backButton={false} noMyPage={true}>
          <ResetPasswordSuccessPage setActivePage={setActivePage} />
        </Layout>
      );
  }
};
